import { render, staticRenderFns } from "./userGroup.vue?vue&type=template&id=2c208223&scoped=true&"
import script from "./userGroup.vue?vue&type=script&lang=js&"
export * from "./userGroup.vue?vue&type=script&lang=js&"
import style0 from "./userGroup.vue?vue&type=style&index=0&id=2c208223&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c208223",
  null
  
)

export default component.exports